import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Obr from "../images/katherine-volkovski-Q_MJjEN14uk-unsplash.jpg"

const SecondPage = () => (
  <Layout>
    <SEO title="Hybrid kukurice Tirnavia" />
    <section className="text-gray-700 body-font overflow-hidden">
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
            <h2 className="text-sm title-font text-gray-500 tracking-widest">
              FAO 280
            </h2>
            <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
              Tirnavia
            </h1>
            <div className="flex mb-4">
              <span className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                Odporúčania pre pestovateľov
              </span>
            </div>
            <p className="leading-relaxed text-justify mb-4">
              Hybrid TIRNAVIA je vzhľadom na svoju skorosť a plasticitu aj v
              suchších podmienkach vhodný pre pestovanie na siláž pre zemiakovú
              oblasť a pre celú repnú oblasť s možnosťou skoršieho zberu v tejto
              oblasti. Vzhľadom na vysokú úrodu siláže poskytuje stabilné úrody
              siláže aj v suchších podmienkach. Do úvahy prichádza v zemiakovej
              a repnej oblasti aj alternatívne využitie na zrno, CCM a LKS, čo
              zvýrazňuje vyššiu univerzálnosť hybrida.
            </p>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ hybridu</span>
              <span className="ml-auto text-gray-900">Tc</span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ zrna</span>
              <span className="ml-auto text-gray-900">medzityp</span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Organizácia porastu:
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">
                Pre pestovanie v repnej oblasti na siláž
              </span>
              <span className="ml-auto text-gray-900">
                100 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">
                Pre pestovanie v zemiakovej oblasti na siláž
              </span>
              <span className="ml-auto text-gray-900">
                90 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">
                Pre pestovanie na zrno, CCM a LKS v zemiakovej a repnej oblasti
              </span>
              <span className="ml-auto text-gray-900">
                85 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Hospodárske vlastnosti:
              </span>
            </div>

            <div className="flex border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vhodnosť pre pestovanie kukurice na siláž v zemiakovej
                    oblasti až po repnú oblasť
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vysoká úroda siláže
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vyššia stráviteľnosť silážnej hmoty v suchých podmienkach
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Stabilita úrody celkovej suchej hmoty
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Možnosť pestovania na zrno v repnej oblasti
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Hybrid kukurice Tirnavia"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={Obr}
          />
        </div>
      </div>
    </section>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výpis výsledkov štátnych odrodových skúšok SR v roku 2009 - 2010
        (priemer lokalít):
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <tbody>
          <tr>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              rowspan="2"
            >
              Hybrid
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Úroda suchej hmoty (t/ha)
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Úroda suchých šúľkov (t/ha)
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2009
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2010
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2009
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2010
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3">TIRNAVIA</td>
            <td className="bg-gray-100 px-4 py-3 ">23,30</td>
            <td className="bg-gray-100 px-4 py-3 ">15,20</td>
            <td className="bg-gray-100 px-4 py-3 ">19,30</td>
            <td className="bg-gray-100 px-4 py-3 ">7,20</td>
            <td className="bg-gray-100 px-4 py-3 ">4,88</td>
            <td className="bg-gray-100 px-4 py-3 ">6,04</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">EDUARDO</td>
            <td className="px-4 py-3 bg-gray-300">15,10</td>
            <td className="px-4 py-3 bg-gray-300">12,70</td>
            <td className="px-4 py-3 bg-gray-300">13,90</td>
            <td className="px-4 py-3 bg-gray-300">6,12</td>
            <td className="px-4 py-3 bg-gray-300">6,05</td>
            <td className="px-4 py-3 bg-gray-300">6,09</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">LG 3225</td>
            <td className="px-4 py-3 bg-gray-300">18,20</td>
            <td className="px-4 py-3 bg-gray-300">14,50</td>
            <td className="px-4 py-3 bg-gray-300">16,40</td>
            <td className="px-4 py-3 bg-gray-300">7,76</td>
            <td className="px-4 py-3 bg-gray-300">5,33</td>
            <td className="px-4 py-3 bg-gray-300">6,55</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výpis výsledkov štátnych odrodových skúšok SR v roku 2009 z Bodorovej
        (zemiaková oblasť):{" "}
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              HYBRID
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Úroda suchej hmoty (t/ha)
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Úroda suchých šúľkov (t/ha)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 ">TIRNAVIA</td>
            <td className="bg-gray-100 px-4 py-3 ">23,50</td>
            <td className="bg-gray-100 px-4 py-3">7,04</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">EDUARDO</td>
            <td className="bg-gray-300 px-4 py-3 ">12,30</td>
            <td className="px-4 py-3 bg-gray-300">4,50</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-200">LG 3225</td>
            <td className="bg-gray-200 px-4 py-3 ">21,10</td>
            <td className="px-4 py-3 bg-gray-200">6,03</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
)

export default SecondPage
